module.exports = __webpack_public_path__ + "img/up-login-black.213f0092.svg";